import { SOCKET_CONNECT, SOCKET_DISCONNECT, SOCKET_SUBSCRIBE, SOCKET_UPDATE, SOCKET_UNSUBSCRIBE } from '../actions/types';
// const sectors = [ 'XLY', 'XLP', 'XLE', 'XLF', 'XLRE', 'XLV', 'XLI', 'XLK', 'XLB', 'XLU', 'XLC'];
// const client = require('socket.io-client');

// let socket = null;

export default function ({ dispatch }) {
  return next => action => {
    switch (action.type) {
      case SOCKET_CONNECT:

        // socket = new client('https://ws-api.iextrading.com/1.0/last');

        // socket.on('message', (response) => {
        //   response = JSON.parse(response);
        //   console.log(response)
        //   if (sectors.indexOf(response.symbol) === -1) {
        //     dispatch({
        //       type: SOCKET_UPDATE,
        //       payload: {
        //         ticker: response.symbol,
        //         price: response.price,
        //         section: 'tickerInfo'
        //       }
        //     });
        //   } else {
        //     dispatch({
        //       type: SOCKET_UPDATE,
        //       payload: {
        //         ticker: response.symbol,
        //         price: response.price,
        //         section: 'sectorInfo'
        //       }
        //     });
        //   }
        // });

        // socket.on('connect', () => {
        //   console.log('Socket connected.');
        //   socket.emit('subscribe', action.payload.join(','));    
        // });

        // socket.on('disconnect', () => {
        //   console.log('Socket disconnected.')
        // });    
      
        break;
      case SOCKET_DISCONNECT:
        // if (socket) {
        //   socket.disconnect();          
        // }
        break;
      case SOCKET_SUBSCRIBE:
        // console.log(action.payload.join(','))
        // socket.emit('subscribe', action.payload.join(','));
        break;
      case SOCKET_UNSUBSCRIBE:
        // console.log(action.payload.join(','))      
        // socket.emit('unsubscribe', action.payload.join(','));      
        break;
      default:
        return next(action);
    }
  }
}